import React from "react";
import { Power, Wifi, WifiOff } from "lucide-react";

interface OnlineToggleProps {
  isOnline: boolean;
  isToggling: boolean;
  isFilaSalgada: boolean;
  isFilaDoce: boolean;
  isFilaSalaoSalgada: boolean;
  isFilaSalaoDoce: boolean;
  isFilaRodizioSalgada: boolean;
  isFilaRodizioDoce: boolean;
  onToggle: () => void;
  onOpenRodizio: () => void;
  onOpenSalao: () => void;
}

const OnlineToggle: React.FC<OnlineToggleProps> = ({
  isOnline,
  isToggling,
  isFilaSalgada,
  isFilaDoce,
  isFilaSalaoSalgada,
  isFilaSalaoDoce,
  isFilaRodizioSalgada,
  isFilaRodizioDoce,
  onToggle,
  onOpenRodizio,
  onOpenSalao,
}) => {
  const filas: { label: string; className: string }[] = [];
  if (isFilaSalgada) {
    filas.push({
      label: "Salgada",
      className: "bg-orange-100 text-orange-700",
    });
  }
  if (isFilaDoce) {
    filas.push({
      label: "Doce",
      className: "bg-pink-100 text-pink-700",
    });
  }
  if (isFilaSalaoSalgada) {
    filas.push({
      label: "Salão Salgada",
      className: "bg-orange-100 text-orange-700",
    });
  }
  if (isFilaSalaoDoce) {
    filas.push({
      label: "Salão Doce",
      className: "bg-pink-100 text-pink-700",
    });
  }
  if (isFilaRodizioSalgada) {
    filas.push({
      label: "Rodízio Salgada",
      className: "bg-amber-100 text-amber-700",
    });
  }
  if (isFilaRodizioDoce) {
    filas.push({
      label: "Rodízio Doce",
      className: "bg-blue-100 text-blue-700",
    });
  }

  const hasAnyFila =
    isFilaSalgada ||
    isFilaDoce ||
    isFilaSalaoSalgada ||
    isFilaSalaoDoce ||
    isFilaRodizioSalgada ||
    isFilaRodizioDoce;

  return (
    <div
      className={`rounded-2xl border-2 p-4 transition-all duration-300 ${
        isOnline
          ? "border-green-300 bg-gradient-to-r from-green-50 to-emerald-50"
          : "border-neutral-200 bg-white"
      }`}
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div
            className={`flex h-10 w-10 items-center justify-center rounded-full transition-colors ${
              isOnline ? "bg-green-500" : "bg-neutral-300"
            }`}
          >
            {isOnline ? (
              <Wifi size={20} className="text-white" />
            ) : (
              <WifiOff size={20} className="text-white" />
            )}
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span
              className={`text-lg font-bold ${isOnline ? "text-green-700" : "text-neutral-600"}`}
            >
              {isOnline ? "Ativo nas filas" : "Inativo nas filas"}
            </span>
            {isOnline && (
              <span className="relative flex h-3 w-3">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
                <span className="relative inline-flex h-3 w-3 rounded-full bg-green-500" />
              </span>
            )}
            {filas.map((fila) => (
              <span
                key={fila.label}
                className={`rounded-full px-2 py-0.5 text-xs font-medium ${fila.className}`}
              >
                {fila.label}
              </span>
            ))}
          </div>
        </div>

        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
          {!isOnline && (
            <>
              <button
                type="button"
                onClick={onOpenRodizio}
                className="w-full rounded-xl bg-primary px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 hover:bg-primary-dark sm:w-auto"
              >
                Rodízio
              </button>
              <button
                type="button"
                onClick={onOpenSalao}
                className="w-full rounded-xl bg-primary px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 hover:bg-primary-dark sm:w-auto"
              >
                Salão
              </button>
            </>
          )}

          <button
            type="button"
            onClick={onToggle}
            disabled={isToggling || !hasAnyFila}
            className={`flex w-full items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto ${
              isOnline
                ? "bg-red-500 hover:bg-red-600"
                : "bg-green-500 hover:bg-green-600"
            }`}
          >
            <Power size={16} />
            {isToggling
              ? "Aguarde..."
              : isOnline
                ? "Ficar Inativo"
                : "Ficar Ativo"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnlineToggle;
